import { Component, OnInit, OnDestroy, HostListener } from '@angular/core';
import { ApiServiceService } from '../../services/api-service.service';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { LoaderService } from '../../services/loader.service';
import { SearchServiceService } from '../../services/search-service.service';
import { environment } from '../../../environments/environment.development';
import { AuthService } from '../../services/auth.service';
import { Subscription } from 'rxjs';
import { GoogleTranslateService } from 'src/app/services/google-translate.service';

import { Subject } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { WalletServiceService } from 'src/app/services/walletService';
// ⬆️ Put this at the very top of header.component.ts (above @Component)
const SEARCH_HISTORY_KEY = 'searchHistory';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
})
export class HeaderComponent implements OnInit, OnDestroy {
  private authSubscription!: Subscription;
  private searchDebounce = new Subject<string>();
  searchHistory: any[] = [];
  isShow = false;
  userDetails: any;
  searchTerm: string = ''; // Declare a variable to store the search input
  cartProducts: any;
  isCollapsed = false;
  totalProducts: number = 0;
  categoriesProduct: any;
  wallet: any;
loading = false;
  dropdownOpen = false;
  searchText = '';
  selectedLanguageCode = 'en'; // default
isMenuOpen = false;
  isProfileMenuOpen = false;

  suggestions: any[] = [];
  showSuggestions: boolean = false;
  isSearching: boolean = false;

  languages = [
    { code: 'en', name: 'English' }, // keep English as base
    { code: 'hi', name: 'Hindi' },
    { code: 'bn', name: 'Bengali' },
    { code: 'te', name: 'Telugu' },
    { code: 'mr', name: 'Marathi' },
    { code: 'ta', name: 'Tamil' },
    { code: 'ur', name: 'Urdu' },
    { code: 'gu', name: 'Gujarati' },
    { code: 'kn', name: 'Kannada' },
    { code: 'ml', name: 'Malayalam' },
    { code: 'or', name: 'Odia' }, // sometimes 'or' / 'od'
    { code: 'pa', name: 'Punjabi' },
    { code: 'as', name: 'Assamese' },
    { code: 'mai', name: 'Maithili' }, // Google uses 'mai'
    { code: 'sd', name: 'Sindhi' },
    { code: 'kok', name: 'Konkani' },
    { code: 'ne', name: 'Nepali' }, // spoken in India too
    { code: 'si', name: 'Sinhala' }, // (less common but in India region)
  ];

  imageUrl = environment.ImageBaseUrl;

  expandedSubCategory: string | null = null;
  suggestionsSubCate: any;
rewardBalance: number = 0;
balance: number = 0;


  constructor(
    private api: ApiServiceService,
    private router: Router,
    public Router: Router,
    private toastr: ToastrService,
    private walletService: WalletServiceService,
    private loader: LoaderService,
    private searchApi: SearchServiceService,
    private authService: AuthService,
    private googleTranslate: GoogleTranslateService,
    

  ) {}

  
  ngOnInit() {
    // 🔹 Debounced listener for live search suggestions
    this.getRewardWallet();
    this.loadSearchHistory();
   this.walletService.balance$.subscribe((balance) => {
    this.balance = balance;
  });



    this.searchDebounce
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe((term) => {
        if (term.length >= 1) {
          this.loadSearchSuggestions(term);
        } else {
          this.suggestions = [];
          this.showSuggestions = false;
        }
      });
    // Initialize auth state
    this.authService.initialize();

    // Subscribe to user changes
    this.authSubscription = this.authService.currentUser$.subscribe((user) => {
      this.userDetails = user;
      if (user) {
        this.getCartList();
      } else {
        this.cartProducts = [];
        this.totalProducts = 0;
      }
    });

    window.addEventListener('cartUpdatedIncreament', (event: any) => {
      this.totalProducts += event.detail; // increase instantly
    });
    window.addEventListener('cartUpdatedDecreament', (event: any) => {
      this.totalProducts -= event.detail; // increase instantly
    });

    // Fetch categories independently of user login
    this.getAllCategories();

   

  }

  ngAfterViewInit(): void {
    this.updateSelectedLanguage();

    // Translation is only needed for visitors who have already selected a
    // language. Avoid downloading Google's sizeable widget for everyone else.
    if (this.selectedLanguageCode !== 'en') {
      this.googleTranslate.initTranslate('google_translate_element', 'en');
    }
  }



getRewardWallet(): void {
    // const userId = this.getCurrentUserId();
 const userId = this.getCurrentUserId();
  if (!userId) {
    console.warn('⚠️ User ID not found');
    return;
  }

  this.walletService.getRewardWallet(userId).subscribe({
    next: (res: any) => {

      this.wallet = res.wallet; // ya res.data (API response ke according)
      // this.rewardBalance = res.wallet.balance; // ya res.data (API response ke according)

      console.log('Reward :', this.wallet);

      this.loading = false;
    },
    error: (err) => {

      console.error('Error fetching reward history:', err);

      this.loading = false;
    }
  });

}
  toggleDropdown() {
    this.dropdownOpen = !this.dropdownOpen;
  }


   // Optional: Helper method if you prefer
  isHomePage(): boolean {
    return this.Router.url === '/' || this.Router.url === '/home';
  }

  filteredLanguages() {
    return this.languages
      .filter((lang) => lang.code !== this.selectedLanguageCode) // hide current
      .filter(
        (lang) =>
          !this.searchText ||
          lang.name.toLowerCase().includes(this.searchText.toLowerCase())
      );
  }

  changeLanguage(langCode: string) {
    const hostname = window.location.hostname.replace(/^www\./, ''); // handle both www and non-www

    // Clear all old googtrans cookies
    ['/', '/en'].forEach((path) => {
      ['', `.${hostname}`, hostname].forEach((domain) => {
        document.cookie = `googtrans=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; domain=${domain}`;
      });
    });

    if (langCode !== 'en') {
      // Set new language cookie
      const gtCookie = `/en/${langCode}`;
      document.cookie = `googtrans=${gtCookie}; path=/; domain=.${hostname}`;
    }

    this.selectedLanguageCode = langCode;
    this.dropdownOpen = false;

    // ⚡ Delay reload to allow cookie propagation
    setTimeout(() => {
      window.location.reload();
    }, 300);
  }

  // Helper to delete cookie on all possible domains
  deleteCookie(name: string, domain: string) {
    const paths = ['/', '/en'];
    const domains = [domain, '.' + domain];
    paths.forEach((path) => {
      domains.forEach((d) => {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=${path}; domain=${d}`;
      });
    });
  }

  updateSelectedLanguage() {
    const match = document.cookie.match(/googtrans=\/en\/([a-z]{2,3})/);
    if (match && match[1]) {
      this.selectedLanguageCode = match[1];
    }
  }

  ngOnDestroy() {
    if (this.authSubscription) {
      this.authSubscription.unsubscribe();
    }
  }

  toggleSubCategory(subCategoryId: string) {
    this.expandedSubCategory =
      this.expandedSubCategory === subCategoryId ? null : subCategoryId;
  }

  toggleDisplay() {
    this.isShow = !this.isShow;
  }

  openProfileMenu(): void {
    this.isProfileMenuOpen = true;
  }

  @HostListener('document:click', ['$event'])
  closeProfileMenuOnClick(event: MouseEvent): void {
    // The menu remains visible after hovering the lock icon, so the cursor can
    // move to Login/Register without the hover state disappearing. Any click
    // (including a menu item or a click elsewhere) closes it.
    this.isProfileMenuOpen = false;
  }

  // toggle() {
  //   this.isCollapsed = !this.isCollapsed;
  // }

  onLogin() {
    this.router.navigate(['Signin', 0]); // we are passing it to open login directly if value is 0
  }
  // Detect clicks outside the side menu
  // @HostListener('document:click', ['$event'])
  // onClickOutside(event: Event): void {
  //   const clickedInsideMenu = this.isClickedInsideMenu(event);
  //   if (!clickedInsideMenu) {
  //     this.isCollapsed = false; // Close the side menu
  //   }
  // }

  // // Check if the click occurred inside the side menu
  // isClickedInsideMenu(event: Event): boolean {
  //   const menuElement = document.querySelector('.bgcolor'); // Select the side menu element
  //   return menuElement?.contains(event.target as Node) || true;
  // }

  myCartPage() {
    if (this.userDetails) {
      this.router.navigate(['steps']);
    } else {
      this.router.navigate(['Signin', 0]);
    }
  }
// walletResponse: any = {
//   success: true,
//   wallets: [
//     {
//       _id: "6a53bec5409f3f673615c117",
//       user_Id: "6753f257fded359438c48fe0",
//       balance: 800,
//       coupon: "SAVE10",
//       description: "mnnmnmmnnmmn",
//       createdAt: "2026-07-12T16:20:21.124Z",
//       updatedAt: "2026-07-12T16:25:17.776Z"
//     }
//   ]
// };
  logOut() {
    const logoutRequest = this.api.logOut();
    this.authService.clearUser();
    this.isProfileMenuOpen = false;
    this.router.navigateByUrl('/', { replaceUrl: true });

    logoutRequest.subscribe(
      (res: any) => {
        if (res.success) {
          this.toastr.success('You have logged out successfully');
        } else {
          this.toastr.error(res.message || 'Logout error occurred');
        }
      },
      (error) => {
        console.error('Logout error:', error);
        this.toastr.error('An error occurred while logging out');
      }
    );
  }

  getCurrentUserId(): string {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        const decodedToken = JSON.parse(atob(token.split('.')[1]));
        return decodedToken.id || '';
      } catch (e) {
        console.error('Error decoding token:', e);
      }
    }
    return '';
  }

  getCartList() {
    const userId = this.getCurrentUserId();
    this.api.getCartList(userId).subscribe((data: any) => {
      this.cartProducts = data.data;
      this.totalProducts = this.cartProducts.length;
    });
  }

  getAllCategories() {
    this.api.getAllCategories().subscribe((data: any) => {
      this.categoriesProduct = data.categories;
    });
  }


getAllWallet(){

   this.walletService.getAllWallet().subscribe(res=>{

      this.wallet=res.data;
console.log(this.wallet)
   });

}
  

  onSearch(): void {
    const term = this.searchTerm.trim();
    this.searchApi.changeSearchTerm(term); // Notify service of search term

    if (term) {
      this.saveSearchToHistory(term);
      this.router.navigate(['/product-list'], {
        queryParams: { search: term },
        queryParamsHandling: 'merge',
      });
    } else {
      this.router.navigate(['/']);
    }
  }

  onSearchInput(event: any): void {
    const term = event.target.value.trim();

      // 🟣 Hide search history when user types (greater than 1 char)
  if (term.length > 1) {
    this.searchHistory = [];
  } else {
    // Show history again when input cleared
    this.loadSearchHistory();
  }

  
    this.searchDebounce.next(term);
  }

  loadSearchSuggestions(term: string): void {
    this.isSearching = true;
    this.api.searchSuggestions(term).subscribe({
      next: (res: any) => {
        this.suggestions = res.data || [];
        console.log("this suggestions" ,this.suggestions)
        this.showSuggestions = true;
        // this.isSearching = false;
        // 🔥 send impression for ALL products (once)
      this.suggestions.forEach((item: any) => {
        this.searchApi.sendImpressionOnce(item.productId);
      });
      },
      error: (err) => {
        console.error('Suggestion error:', err);
        this.suggestions = [];
        this.isSearching = false;
      },
    });
  }

  selectSuggestion(suggestion: any): void {
    this.showSuggestions = false;
    this.searchTerm = suggestion.keyword;
    this.saveSearchToHistory(suggestion.keyword);

    this.router.navigate(['/product-list'], {
      queryParams: { search: suggestion.keyword },
      queryParamsHandling: 'merge',
    });
  }

  // selectSuggestion(item: any): void {
  //   this.showSuggestions = false;

  //   // 🟢 CASE 1: Product result (has productDetails)
  //   if (item.productDetails) {
  //     this.searchTerm = item.productDetails?.productName || item.name;
  //     this.router.navigate(['product-details', item._id], { state: { product: item } });
  //   }
  //   // 🟣 CASE 2: Category-based result (has subSubcategory or category object)
  //   else if (item.subSubcategory.name) {
  //     const categoryId = item.subSubcategory?._id
  //     const categoryName = item.subSubcategory?.name

  //     this.searchTerm = categoryName;

  //     this.router.navigate(['/product-list' , item.subSubcategory._id], {
  //       queryParams: {
  //         category: categoryId,
  //         search: categoryName
  //       },
  //       queryParamsHandling: 'merge'
  //     });
  //   }
  //   // 🟠 CASE 3: Brand or fallback
  //   else {
  //     this.searchTerm = item.subSubcategory.name || '';
  //     this.router.navigate(['/product-list'], {
  //       queryParams: { search: this.searchTerm },
  //       queryParamsHandling: 'merge'
  //     });
  //   }
  // }

  hideSuggestions(): void {
    // small delay to allow click selection
    setTimeout(() => (this.showSuggestions = false), 200);
  }

  orderList() {
    this.router.navigate(['profile-details', { pageName: 'myorder' }]); // we are passing it to open login directly if value is 0
  }

  wishList() {
    this.router.navigate(['profile-details', { pageName: 'mywishlist' }]); // we are passing it to open login directly if value is 0
  }
  notification() {
    this.router.navigate(['profile-details', { pageName: 'notification' }]); // we are passing it to open login directly if value is 0
  }

  categroies(id: any) {
    this.router.navigate(['product-list', id]);
    this.isCollapsed = false;
  }

  categroiesSub(id: any) {
    this.router.navigate(['product-list', id]);
    this.isCollapsed = false;
  }

  categroiesSubSub(id: any) {
    this.router.navigate(['product-list', id]);
    this.isCollapsed = false;
  }
  loadSearchHistory(): void {
    this.searchHistory = JSON.parse(
      localStorage.getItem(SEARCH_HISTORY_KEY) || '[]'
    );
  }

  useHistorySearch(item: any): void {
    this.searchTerm = item.term;
    this.onSearch();
  }

  saveSearchToHistory(term: string, product?: any): void {
    let history = JSON.parse(localStorage.getItem(SEARCH_HISTORY_KEY) || '[]');

    // Create a record
    const newEntry = {
      term,
      productId: product?._id || null,
      productName: product?.productDetails?.productName || null,
      timestamp: new Date().toISOString(),
    };

    // Prevent duplicates — remove existing same term
    history = history.filter(
      (item: any) => item.term.toLowerCase() !== term.toLowerCase()
    );

    // Add to start of history
    history.unshift(newEntry);

    // Keep only last 10
    history = history.slice(0, 5);

    // Save back
    localStorage.setItem(SEARCH_HISTORY_KEY, JSON.stringify(history));
    console.log('SEARCH_HISTORY_KEY--?', history);
  }




  
}
